import { DanfeLabelBarcodeMode } from '../../../enums/DanfeLabelBarcodeMode';

export class GetDanfePackingLabelInput {
    orderIds: number[];
    barcodeMode?: DanfeLabelBarcodeMode;
}